// frontend/src/components/LogoUpload.js
import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { updateUser } from "../store/slices/authSlice";
import axios from "axios";

const LogoUpload = ({ currentLogo, onLogoUpload, loading }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      enqueueSnackbar(t("auth.profile.logoSizeError"), { variant: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("logo", file);

    setUploadLoading(true);

    try {
      const response = await axios.post("/api/user/logo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.data.success) {
        dispatch(updateUser(response.data.user));
        enqueueSnackbar(t("auth.profile.logoUploadSuccess"), {
          variant: "success",
        });
        if (onLogoUpload) {
          onLogoUpload(response.data);
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      enqueueSnackbar(t("auth.profile.logoUploadError"), { variant: "error" });
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <Box sx={{ textAlign: "center", my: 2 }}>
      <Avatar
        src={currentLogo}
        sx={{
          width: 150,
          height: 150,
          mx: "auto",
          mb: 2,
          bgcolor: "primary.light",
        }}
        alt={t("auth.profile.companyLogo")}
      />
      <input
        accept="image/*"
        style={{ display: "none" }}
        id="logo-upload"
        type="file"
        onChange={handleFileSelect}
        disabled={uploadLoading}
      />
      <label htmlFor="logo-upload">
        <Button
          component="span"
          variant="contained"
          startIcon={
            uploadLoading ? <CircularProgress size={20} /> : <CloudUpload />
          }
          disabled={uploadLoading}
        >
          {t("auth.profile.uploadLogo")}
        </Button>
      </label>
      <Typography variant="caption" display="block" sx={{ mt: 1 }}>
        {t("auth.profile.logoRequirements")}
      </Typography>
    </Box>
  );
};

export default LogoUpload;
